import './index_mWeb.css';
import Card from '../card';
import moment from 'moment';
import { useState } from 'react';
import View from '../view';
import Text from '../text';
import Constants from '../../constants';
import React from 'react';
import useTheme from '../../utilities/hooks/theme';
import { convertToDollars } from '../../utilities/helper';

interface Props {
  item: any;
  newAmountText: any;
  statusText: any;
  statusColor: any;
  //   walletType?: any;
}
const TransactionItemMWeb = ({
  item,
  newAmountText,
  statusText,
  statusColor
}: // walletType
Props) => {
  const { AccountTheme: theme } = useTheme();

  const [expanded, setExpanded] = useState(false);
  const {
    createdOn = '',
    modifiedOn = '',
    purpose = '',
    gateway = '',
    transactionId = '',
    status = '',
    comment = '',
    _id = '',
    tComment = '',
    walletAddress = ''
  } = item;

  const surfaceColor = {
    backgroundColor: '#202a38',
    boxShadow: '0 3px 16px 0 rgba(0, 0, 0, 0.16)'
  };

  const simpleTextColor = {
    color: theme.transactionDateTime
  };

  const contentTextColor = {
    color: theme.transactionContentText
  };

  const expandDivider = {
    backgroundColor: theme.transactionExpandIconBorder
  };

  const contentColor = {
    borderTopColor: theme.transactionExpandIconBorder
  };

  return (
    <Card key={_id} className={'transaction-item-container__mWeb'} style={surfaceColor}>
      <View
        onPress={() => setExpanded(!expanded)}
        className={'transaction-item-header'}
        style={{ borderLeft: `8px solid ${statusColor}` }}>
        <View className={'transaction-item-header-wrapper '}>
          <View className={'transaction-item-left-part__mWeb'}>
            <Text className={'transaction-item-header-text'} style={{ color: statusColor }}>
              {statusText}
            </Text>
            <Text className={'transaction-item-simple-text'} style={simpleTextColor}>
              {moment(new Date(createdOn || modifiedOn), 'YYYY-MM-DD HH:mm:ss').format(
                'DD-MM-YYYY HH:mm:ss'
              )}
            </Text>
            {tComment?.toLowerCase()?.includes('Leaderboard Prize'.toLowerCase()) && (
              <Text className={'transaction-item-simple-text'} style={simpleTextColor}>
                {comment}
              </Text>
            )}
          </View>
          <View className={'transaction-item-right-part__mWeb'}>
            <Text className={'transaction-item-amount-text'} style={{ color: statusColor }}>
              {status === 'expired'
                ? `- ${convertToDollars(newAmountText)}`
                : `${convertToDollars(newAmountText)}`}
            </Text>
          </View>
        </View>
        <View className={'transaction-item-expand-divider'} style={expandDivider} />
        <View className={'transaction-item-expand-wrapper'}>
          {expanded ? (
            <Constants.Svgs.ArrowCollapse fill={theme.transactionExpandIcon} />
          ) : (
            <Constants.Svgs.ArrowExpand fill={theme.transactionExpandIcon} />
          )}
        </View>
      </View>
      {expanded && (
        <View
          className={'transaction-item-content'}
          style={{ ...contentColor, borderLeft: `8px solid ${statusColor}` }}>
          <div className="transactionItem__content__wrapper__mWeb">
            <Text
              className={'transaction-item-content-text'}
              style={contentTextColor}>{`Status : `}</Text>
            <Text
              className={'transaction__item__content__value__mWeb'}
              style={contentTextColor}>{` ${status ? status : 'NA'}`}</Text>
          </div>
          <div className="transactionItem__content__wrapper__mWeb">
            <Text className={'transaction-item-content-text'} style={contentTextColor}>
              {`Transaction Id : `}
            </Text>
            <Text className={'transaction__item__content__value__mWeb'} style={contentTextColor}>
              {`${transactionId ? transactionId : 'NA'}`}
            </Text>
          </div>
          <div className="transactionItem__content__wrapper__mWeb">
            <Text
              className={'transaction-item-content-text'}
              style={contentTextColor}>{`Gateway : `}</Text>
            <Text className={'transaction__item__content__value__mWeb'} style={contentTextColor}>
              {`${gateway ? gateway : 'NA'}`}
            </Text>
          </div>
          <div className="transactionItem__content__wrapper__mWeb">
            <Text
              className={'transaction-item-content-text'}
              style={contentTextColor}>{`Purpose : `}</Text>
            <Text className={'transaction__item__content__value__mWeb'} style={contentTextColor}>
              {`${purpose ? purpose : 'NA'}`}
            </Text>
          </div>
          {walletAddress && (
            <div className="transactionItem__content__wrapper__mWeb">
              <Text
                className={'transaction-item-content-text'}
                style={contentTextColor}>{`Withdraw Address : `}</Text>
              <Text className={'transaction__item__content__value__mWeb'} style={contentTextColor}>
                {`${walletAddress ? walletAddress : 'NA'}`}
              </Text>
            </div>
          )}
        </View>
      )}
    </Card>
  );
};
export default React.memo(TransactionItemMWeb);
